import { useState, useEffect } from 'react';
import {
    authLogin,
    validateToken
} from '../services/AuthServices';

export const useAuth = () => {

    const [auth, setAuth] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const authPost = async (data) => {
        try {
            const response = await authLogin(data);
            if (response?.data?.status == 400) {
                setError('Login Failed!!');
            }
            setAuth(response?.data)
            return response?.data
        } catch {
            setError('Failed!!');
        }
    };


    const validate = async () => {
        try {
            setLoading(true);
            const response = await validateToken();
            if (response?.data?.status == 400) {
                setError('Login Failed!!');
            }

            setAuth(response?.data)
        } catch {
            setError('Failed!!');
        }
        setLoading(false)
    };

    useEffect(() => {
    }, [validate]);

    return { loading, error, auth, authPost, validate };
};
